<template>
  <div class="layout-column">

    <!-- Menopausenstatus -->

    <div class="flex-100 px-2 mb-5">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_MAMMA_MENO_BREAK')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.praetherapeutischer_menopausenstatus'"
                             :ref="path + '.praetherapeutischer_menopausenstatus'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 pb-3 pt-1 flex">
            <v-radio-group :dense="denseFields" v-model="model.praetherapeutischer_menopausenstatus" hide-details row :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_MENO_BREAK_RADIO_BUTTONS.PRAE_MENO')"
                       value="1" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_MENO_BREAK_RADIO_BUTTONS.POST_MEON')"
                       value="3" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_MENO_BREAK_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of praetherapeutischer_menopausenstatus via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center"
                     @click="resetRadioButtons('praetherapeutischer_menopausenstatus')"
                     v-show="model.praetherapeutischer_menopausenstatus && !isDisabled"
                     :disabled="!model.praetherapeutischer_menopausenstatus || isDisabled"
                     :title="$t('buttons.deleteSelection.title')"
                     style="max-height:24px;">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Hormonrezeptorstatus Östrogen -->

    <div class="flex-100 px-2 mb-5">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HORMONE_RECEPTOR_ESTROGEN')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.hormonrezeptor_status_oestrogen'"
                             :ref="path + '.hormonrezeptor_status_oestrogen'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 pb-3 pt-1 flex">
            <v-radio-group :dense="denseFields" v-model="model.hormonrezeptor_status_oestrogen" row hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HORMON_RECEPTOR_RADIO_BUTTONS.POSITIVE')"
                       value="P" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HORMON_RECEPTOR_RADIO_BUTTONS.NEGATIVE')"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HORMON_RECEPTOR_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of hormonrezeptor_status_oestrogen via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center"
                     @click="resetRadioButtons('hormonrezeptor_status_oestrogen')"
                     v-show="model.hormonrezeptor_status_oestrogen && !isDisabled"
                     :disabled="!model.hormonrezeptor_status_oestrogen || isDisabled"
                     :title="$t('buttons.deleteSelection.title')"
                     style="max-height:24px;">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Hormonrezeptorstatus Progesteron -->

    <div class="flex-100 px-2 mb-5">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HORMONE_RECEPTOR_PROGESTERON')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.hormonrezeptor_status_progesteron'"
                             :ref="path + '.hormonrezeptor_status_progesteron'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 pb-3 pt-1 flex">
            <v-radio-group :dense="denseFields" v-model="model.hormonrezeptor_status_progesteron" row hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HORMON_RECEPTOR_RADIO_BUTTONS.POSITIVE')"
                       value="P" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HORMON_RECEPTOR_RADIO_BUTTONS.NEGATIVE')"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HORMON_RECEPTOR_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of hormonrezeptor_status_progesteron via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center"
                     @click="resetRadioButtons('hormonrezeptor_status_progesteron')"
                     v-show="model.hormonrezeptor_status_progesteron && !isDisabled"
                     :disabled="!model.hormonrezeptor_status_progesteron || isDisabled"
                     :title="$t('buttons.deleteSelection.title')"
                     style="max-height:24px;">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Her2 Neu -->

    <div class="flex-100 px-2 mb-5">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HER2_NEW')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.her_2_neu_status'"
                             :ref="path + '.her_2_neu_status'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 pb-3 pt-1 flex">
            <v-radio-group :dense="denseFields" v-model="model.her_2_neu_status" row hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HER2_NEW_RADIO_BUTTONS.POSITIVE')"
                       value="P" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HER2_NEW_RADIO_BUTTONS.NEGATIVE')"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_HER2_NEW_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of her_2_neu_status via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center"
                     @click="resetRadioButtons('her_2_neu_status')"
                     v-show="model.her_2_neu_status && !isDisabled"
                     :disabled="!model.her_2_neu_status || isDisabled"
                     :title="$t('buttons.deleteSelection.title')"
                     style="max-height:24px;">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>

            <!-- Message to FISH "borderline" -->

            <div class="mt-4 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
                 :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
                 :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
              <div class="layout-column layout-align-center-center mr-3">
                <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
              </div>
              <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_MAMMA_HER2_MESSAGE') }}</span>
            </div>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Präoperative Drahtmarkierung -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_MAMMA_PRAEOP_WIRE_MARKING')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.praeop_drahtmarkierung'"
                             :ref="path + '.praeop_drahtmarkierung'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 pb-3 pt-1 flex">
            <v-radio-group :dense="denseFields" v-model="model.praeop_drahtmarkierung" hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_PRAEOP_WIRE_MARKING_RADIO_BUTTONS.MAMMOGRAPHIE')"
                       value="M" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_PRAEOP_WIRE_MARKING_RADIO_BUTTONS.SONOGRAPHIE')"
                       value="S" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_PRAEOP_WIRE_MARKING_RADIO_BUTTONS.MRT')"
                       value="T" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_PRAEOP_WIRE_MARKING_RADIO_BUTTONS.NO_WIRE_MARKING')"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_PRAEOP_WIRE_MARKING_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of praeop_drahtmarkierung via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-3' : ''"
                     @click="resetRadioButtons('praeop_drahtmarkierung')"
                     v-show="model.praeop_drahtmarkierung && !isDisabled"
                     :disabled="!model.praeop_drahtmarkierung || isDisabled"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-up-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Intraoperatives Präparatröntgen/Sonografie -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_MAMMA_INTRA_OP_X_RAY')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.intraop_praeparatkontrolle'"
                             :ref="path + '.intraop_praeparatkontrolle'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 pb-4 pt-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.intraop_praeparatkontrolle" hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_INTRA_OP_X_RAY_RADIO_BUTTONS.MAMMOGRAPHIE')"
                       value="M" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_INTRA_OP_X_RAY_RADIO_BUTTONS.SONOGRAPHIE')"
                       value="S" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_INTRA_OP_X_RAY_RADIO_BUTTONS.NO')"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_MAMMA_INTRA_OP_X_RAY_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of intraop_praeparatkontrolle via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-3' : ''"
                     @click="resetRadioButtons('intraop_praeparatkontrolle')"
                     v-show="model.intraop_praeparatkontrolle && !isDisabled"
                     :disabled="!model.intraop_praeparatkontrolle || isDisabled"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-up-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Tumorgröße invasives Karzinom -->

    <div class="flex-gt-sm-100 flex-100 px-2 layout-row">
      <validation-provider tag="div"
                           class="flex-gt-sm-50 flex-100"
                           :name="path + '.tumorgroesse_invasiv.groesse'"
                           :ref="path + '.tumorgroesse_invasiv.groesse'"
                           :rules="{integer: true,between:[0,999]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="model.tumorgroesse_invasiv.u==='U' || isDisabled"
                        :dense="denseFields"
                        v-model="model.tumorgroesse_invasiv.groesse"
                        :label="$t('FORMS_DIVERSE.MODULE_MAMMA_TUMOR_SIZE')"
                        separator=","
                        suffix="mm"
                        :maxLength="3"
                        @input="refactorEmptyIntValue(model.tumorgroesse_invasiv.groesse, 'tumorgroesse_invasiv', 'groesse')"
                        :hint="$t('FORMS_DIVERSE.MODULE_PROSTATA_TUMOR_SIZE_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>

      <div class="pl-5">
        <validation-provider tag="div"
                             class="flex-gt-sm-50 flex-100"
                             :name="path + '.tumorgroesse_invasiv.u'"
                             :ref="path + '.tumorgroesse_invasiv.u'"
                             rules=""
                             v-slot="{ errors }">
          <v-checkbox :label="$t('FORMS_DIVERSE.UNKNOWN')"
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      v-model="model.tumorgroesse_invasiv.u"
                      value="U"
                      :error-messages="errors[0]"
                      :class="denseFields ? 'mt-n1' : 'mt-0'"
                      class="py-0"
                      @change="model.tumorgroesse_invasiv.groesse=null"
                      :disabled="isDisabled">
          </v-checkbox>
        </validation-provider>
      </div>
    </div>

    <!-- Tumorgröße DCIS -->

    <div class="flex-gt-sm-100 flex-100 px-2 layout-row">
      <validation-provider tag="div"
                           class="flex-gt-sm-50 flex-100"
                           :name="path + '.tumorgroesse_dcis.groesse'"
                           :ref="path + '.tumorgroesse_dcis.groesse'"
                           :rules="{integer: true,between:[1,999]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="model.tumorgroesse_dcis.u==='U' || isDisabled"
                        :dense="denseFields"
                        v-model="model.tumorgroesse_dcis.groesse"
                        :label="$t('FORMS_DIVERSE.MODULE_MAMMA_TUMOR_SIZE_DCIS')"
                        separator=","
                        suffix="mm"
                        :maxLength="3"
                        @input="refactorEmptyIntValue(model.tumorgroesse_dcis.groesse, 'tumorgroesse_dcis', 'groesse')"
                        :hint="$t('FORMS_DIVERSE.MODULE_PROSTATA_TUMOR_SIZE_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>

      <div class="pl-5">
        <validation-provider tag="div"
                             class="flex-gt-sm-50 flex-100"
                             :name="path + '.tumorgroesse_dcis.u'"
                             :ref="path + '.tumorgroesse_dcis.u'"
                             rules=""
                             v-slot="{ errors }">
          <v-checkbox :label="$t('FORMS_DIVERSE.UNKNOWN')"
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      v-model="model.tumorgroesse_dcis.u"
                      value="U"
                      :class="denseFields ? 'mt-n1' : 'mt-0'"
                      class="py-0"
                      @change="model.tumorgroesse_dcis.groesse=null"
                      :error-messages="errors[0]"
                      :disabled="isDisabled">
          </v-checkbox>
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../../common/utils'

export default {
  name: "ModulMamma",
  mixins: [utils],
  props: {
    value: {
      type: Object,
      default: () => ({
        tumorgroesse_invasiv: {},
        tumorgroesse_dcis: {}
      })
    },
    path: {
      type: String
    },
    base: {
      type: Object
    },
    isDisabled: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visible: false,
      model: {
        tumorgroesse_invasiv: {},
        tumorgroesse_dcis: {}
      }
    }
  },
  methods: {
    /**
     * Reset selected radio-button and trigger dirty flag of validator for save
     */
    resetRadioButtons (field) {
      this.$set(this.model, field, null)
      this.validationRef.fields[this.path + '.' + field].changed = true
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    },
    'base.primaertumor_icd_code': {
      // reset module if already existing icd10 code has been changed
      handler: function (newValue, oldValue) {
        if (newValue && oldValue && newValue !== oldValue && !this.isDisabled) {
          this.model = {
            tumorgroesse_invasiv: {},
            tumorgroesse_dcis: {}
          }
        }
      },
      immediate: true
    }
  }
}
</script>
